import { type PreloadedQuery } from 'react-relay';
import { type GraphQLResponse } from 'relay-runtime';

import type { SearchPageState } from '../../../common/constants/relay/types';
import { type AbortablePromise } from '../../../common/utils/abortable-promise';
import { type DisposablePromise } from '../../../common/utils/disposable-promise';
import { type DisposableValue, disposableValues } from '../../../common/utils/disposable-value';
import type { FetchLeapQueryProps } from '../../../common/utils/leap-query';
// eslint-disable-next-line @atlassian/tangerine/import/no-parent-imports
import type { rightPanelQuery } from '../right-panel/__generated__/rightPanelQuery.graphql';
// eslint-disable-next-line @atlassian/tangerine/import/no-parent-imports
import type { searchResultsQuery } from '../search-results/__generated__/searchResultsQuery.graphql';

/**
 * Holds preloaded values for search results and right panel queries along
 * with the current search page state and leap query props.
 **/
export const PRELOAD_VALUES = disposableValues<
	[
		DisposableValue<PreloadedQuery<searchResultsQuery>>,
		DisposableValue<PreloadedQuery<rightPanelQuery>>,
		SearchPageState,
		FetchLeapQueryProps,
		DisposablePromise<AbortablePromise<[GraphQLResponse | undefined, GraphQLResponse | undefined]>>,
		DisposableValue<unknown>, // Used for cleanup purposes
	]
>();
